import Fragment from "../../football/fragments/fragment";
import FragmentDataType from "../../football/enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";

export default class FlagPatBlocked extends Fragment {
    constructor(blockedBy, returnedBy, patScoreType) {
        super();
        this.result = "B";
        this.blockedBy = blockedBy;
        this.returnedBy = returnedBy;
        this.patScoreType = patScoreType;

        this.requiredData = [
            {
                name: "blockedBy",
                type: FragmentDataType.Player,
                displayName: "Blocked by",
                appliesToOpponent: () => true,
                isEditable: true
            },
            {
                name: "returnedBy",
                type: FragmentDataType.Player,
                displayName: "Returned by",
                isEditable: true
            },
            {
                name: "patScoreType",
                type: FragmentDataType.PatScoreType,
                displayName: "Score type"
            }
        ];
    }

    getFragmentTeamId() {
        return this.blockedBy?.teamId;
    }

    getPlayers() {
        return [this.blockedBy, this.returnedBy];
    }

    toJSON() {
        return {
            ...super.toJSON(),
            blockedBy: playerReducer(this.blockedBy),
            returnedBy: playerReducer(this.returnedBy)
        };
    }
}
